function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  html, body {\n    margin: 0;\n    color: ", ";\n    line-height: 1.4;\n  }\n\n  a, a:hover {\n    color: ", ";\n    text-decoration: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React from 'react';
import { createGlobalStyle } from '@xstyled/styled-components';
import { th } from '@xstyled/system';
import { Normalize } from '@smooth-ui/core-sc';
var LocalGlobalStyle = createGlobalStyle(_templateObject(), th.color('text'), th.color('primary'));
export function GlobalStyle() {
  return React.createElement(React.Fragment, null, React.createElement(Normalize, null), React.createElement(LocalGlobalStyle, null));
}